import React, { useState, useContext } from "react";

// Context //
import TalentsContext from "../../../contexts/talentsContext";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";

// Styles //
import "./searchFilterEncTal.scss";

const SearchFilterEncTal = () => {
    const [query, setQuery] = useState("");
    const {
        selectedFilters,
        setKeyWord,
        setSelectedFilters,
        onSubmitSearchHandler,
    } = useContext(TalentsContext);
    const { isBrowser, document } = useBrowserMode();

    const pathName = isBrowser ? window.location.pathname: '';

    return (
        <form
            className="m-search-filter"
            onSubmit={(e) => {
                e.preventDefault();
                onSubmitSearchHandler();
                setSelectedFilters({
                    ...selectedFilters,
                    keyWord: {
                        ...selectedFilters.keyWord,
                        items: [
                            {
                                label: query,
                                value: "keyWord",
                                name: "keyWord",
                            },
                        ],
                    },
                });
                setKeyWord(query);
                setQuery("");
            }}
        >
            <p className="m-search-filter__title">¿Qué perfil estás buscando?</p>
            <div className="m-search-filter__inner">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22.536"
                    height="22.536"
                    viewBox="0 0 22.536 22.536"
                    className="m-search-filter__inner__icon"
                >
                    <path
                        id="Trazado_38818"
                        data-name="Trazado 38818"
                        d="M22.223-3.053,16.667-8.684a8.882,8.882,0,0,0,1.99-4.28,9.335,9.335,0,0,0-.375-4.693A9.287,9.287,0,0,0,15.653-21.6a9.181,9.181,0,0,0-4.167-2.177,9.621,9.621,0,0,0-4.693.113A9.008,9.008,0,0,0,2.7-21.3,9.008,9.008,0,0,0,.337-17.206a9.621,9.621,0,0,0-.113,4.693A9.181,9.181,0,0,0,2.4-8.347,9.287,9.287,0,0,0,6.344-5.719a9.335,9.335,0,0,0,4.693.375,8.882,8.882,0,0,0,4.28-1.99l5.631,5.556a.751.751,0,0,0,.638.3.915.915,0,0,0,.676-.263.915.915,0,0,0,.263-.676A.751.751,0,0,0,22.223-3.053ZM9.384-7.108A7.286,7.286,0,0,1,5.63-8.121a7.571,7.571,0,0,1-2.74-2.74,7.286,7.286,0,0,1-1.014-3.754A7.286,7.286,0,0,1,2.89-18.37a7.571,7.571,0,0,1,2.74-2.74,7.286,7.286,0,0,1,3.754-1.014,7.286,7.286,0,0,1,3.754,1.014,7.571,7.571,0,0,1,2.74,2.74,7.286,7.286,0,0,1,1.014,3.754,7.286,7.286,0,0,1-1.014,3.754,7.571,7.571,0,0,1-2.74,2.74A7.286,7.286,0,0,1,9.384-7.108Z"
                        transform="translate(0.013 24.013)"
                        fill="#6f7287"
                    />
                </svg>
                <input
                    value={query}
                    type="text"
                    placeholder="Buscar"
                    name="searchInput"
                    id="searchInput"
                    onChange={(e) => {
                        setQuery(e.target.value);
                    }}
                />
                <button disabled={query ? false : true} className={
                        pathName.split('/')[3] == "encontrar_talento" ? `gtm_${pathName.split('/')[3]}_boton_buscar_filtros` : ``}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="19.596"
                        height="16.949"
                        viewBox="0 0 19.596 16.949"
                    >
                        <path
                            id="Trazado_38810"
                            data-name="Trazado 38810"
                            d="M18.935-26.55a1.126,1.126,0,0,0-.45.957,1.126,1.126,0,0,0,.45.957l4.617,4.617L8.911-19.9a1.3,1.3,0,0,0-.957.394,1.3,1.3,0,0,0-.394.957,1.5,1.5,0,0,0,.394,1.014,1.227,1.227,0,0,0,.957.45L23.552-17.2l-4.617,4.73a1.39,1.39,0,0,0-.394,1.351,1.282,1.282,0,0,0,1.014,1.014,1.275,1.275,0,0,0,1.408-.45l5.068-4.955a4.355,4.355,0,0,0,1.126-3.041,4.355,4.355,0,0,0-1.126-3.041L20.962-26.55A1.4,1.4,0,0,0,19.948-27,1.4,1.4,0,0,0,18.935-26.55Z"
                            transform="translate(-7.56 27)"
                            fill="#fff"
                        />
                    </svg>
                </button>
            </div>
        </form>
    );
};

export default SearchFilterEncTal;
